import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";
import type { ProspectListContactEntry } from "../../../api/client.ts";

interface ContactNoteCellProps {
  entry: ProspectListContactEntry;
  onSave: (note: string | null) => void;
}

/** Inline note editor — saves on blur when the value actually changed. */
export default function ContactNoteCell({ entry, onSave }: ContactNoteCellProps) {
  const [value, setValue] = useState(entry.note ?? "");

  // Keep in sync when the entry is refetched (SSE or another user's edit).
  useEffect(() => {
    setValue(entry.note ?? "");
  }, [entry.note]);

  return (
    <TextField
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={() => {
        const next = value.trim();
        if ((entry.note ?? "") !== next) onSave(next || null);
      }}
      size="small"
      variant="standard"
      placeholder="Add note…"
      fullWidth
    />
  );
}
